import api from './api';

export const recursoService = {
  getAll,
  getById,
  create,
  update,
  destroy
};

function getAll(page = 1, limit = 25, status = '', query = '') {
  let queryStr = `?page=${page}&limit=${limit}${status && `&status=${status}`}${query && `&query=${query}`}`;
  return api.get(`${process.env.VUE_APP_ROOT_API}/recursos${queryStr}`);
}

function getById(id) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/recursos/${id}`);
}

function create(recurso) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/recursos`, recurso);
}

function update(recurso) {
  return api.put(`${process.env.VUE_APP_ROOT_API}/recursos/${recurso._id}`, recurso);
}

function destroy(id) {
  return api.delete(`${process.env.VUE_APP_ROOT_API}/recursos/${id}`);
}